import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const reviewTestimonialSliderBlocks = document.querySelectorAll(
	'.block-review-testimonials'
);

if (reviewTestimonialSliderBlocks.length > 0) {
	reviewTestimonialSliderBlocks.forEach((block, index) => {
		const slider = block.querySelector('.swiper');

		if (!slider) {
			return;
		}

		const slides = slider?.querySelectorAll('.swiper-slide');
		const prevButton = block?.querySelector('.swiper-button-prev');
		const nextButton = block?.querySelector('.swiper-button-next');
		let sliderInstance = null;

		prevButton?.addEventListener('click', (e) => {
			e.preventDefault();
			sliderInstance.slidePrev();
		});

		nextButton?.addEventListener('click', (e) => {
			e.preventDefault();
			sliderInstance.slideNext();
		});

		slider.parentElement.classList.add(
			`block-review-testimonials__swiper--${index}`
		);

		const settings = {
			autoHeight: false,
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
		};

		sliderInstance = new Swiper(slider, settings);
	});
}
